export default (params, { location }) => {
  const { hidden, sortBy, status } = location.query;
  return {
    ...params,
    count: 10,
    visibility: hidden === 'true' ? ['SHOW', 'HIDDEN'] : ['SHOW'],
    sortBy: sortBy || 'UPCOMING',
    booking_status: status && status !== 'ALL' ? [status] : ['BOOKED', 'INITIAL', 'CANCELED']
  };
};



// WEBPACK FOOTER //
// ./webpack/routes/params/EventListParams.js